import { faCalendar, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import RequestModalRemove from './RequestModalRemove';

function RequestList({ data }) {
  //Модальные окна
  const [modalRemoveShow, setModalRemoveShow] = useState(false);
  const [modelRemove, setModelRemove] = useState([]);

  function modalRemoveShowEvent(model) {
    setModalRemoveShow(true)
    setModelRemove(model)
  }

  return (
    <>
      {modalRemoveShow && (<RequestModalRemove show={modalRemoveShow} onHide={() => setModalRemoveShow(false)} model={modelRemove} />)}

      {data.map((model) => (
        <div key={model.ID_User} className="list_item mt-15">
          <div className='ml-10' style={{ width: '100%' }}>
            <div className='title'>{model.User_Name}</div>
            <div className='subtitle'><FontAwesomeIcon icon={faCalendar} className='mr-5' />{new Date(model.Date_Add).toLocaleDateString()}</div>
          </div>
          <div className='end'>
            <button className="border-0 btn-transition btn btn-outline-danger"  onClick={() => modalRemoveShowEvent(model)}>
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </div>
        </div>
      ))}
    </>
  );
}

export default RequestList;